import { CoreInitiativesFilesByIdName } from './name';
import { coreInitiativesFilesUpdateSyncSlice } from '../update';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchInitiativeFile } from '@api';

export const coreInitiativesFilesByIdPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ coreInitiativesFilesUpdateSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesFilesByIdName,
	receive: false,
	request: true,
	requestHandler: patchInitiativeFile
});
